/// <reference types="@types/googlemaps" />
/*global google*/

import _ from "lodash";
import { calculateColor, getPinColorValue } from "./colorHelper";
import { formatValue } from "utilities/format";
import defaultPropertyIcon from "assets/images/rex/default-property.png";
import satellitePropertyIcon from "assets/images/rex/satellite-property.png";
import selectedPropertyIcon from "assets/images/rex/selected-property.png";
import defaultAggregateIcon from "assets/images/rex/default-aggregate.png";
import satelliteAggregateIcon from "assets/images/rex/satellite-aggregate.png";
import selectedAggregateIcon from "assets/images/rex/selected-aggregate.png";
import { Constants } from "utilities/constants";

const MAX_DELTA = 0.0001;
const DEFAULT_FILL = "#308085"; //rgb(75, 156, 161)
const SATELLITE_DEFAULT_FILL = "#ffff00"; //rgb(255, 255, 0)
// const SATELLITE_DEFAULT_FILL = DEFAULT_FILL; //rgb(255, 255, 0)
const SELECTED_FILL = "#e58c00"; //rgb(229, 140, 0)
const HIGHLIGHTED_FILL = "#fff700";
const DEFAULT_NO_DATA = "#afafaf" //rgb(175, 175, 175)
const SATELLITE_DEFAULT_NO_DATA = "#ffffff" //rgb(255, 255, 255)

export function isSatelliteMode(mapType) {
  if (mapType === window.google.maps.MapTypeId.SATELLITE || mapType === window.google.maps.MapTypeId.HYBRID || mapType?.includes('satellite')) {
    return true;
  }
  return false;
}

export function hasBoundsChanged(newLocation, oldBounds, maxDelta = MAX_DELTA) {
    if (newLocation == null || oldBounds == null || newLocation.bounds == null)
        return false;

    const exceedsDelta = (bound1, bound2) => {
      return Math.abs(bound1 - bound2) > maxDelta;
    }

    // if (newLocation.bounds[0] != oldBounds[0] ||
    //         newLocation.bounds[1] != oldBounds[1] ||
    //             newLocation.bounds[2] != oldBounds[2] ||
    //                 newLocation.bounds[3] != oldBounds[3])
    // {
    if (exceedsDelta(newLocation.bounds[0], oldBounds[0]) ||
            exceedsDelta(newLocation.bounds[1], oldBounds[1]) ||
                exceedsDelta(newLocation.bounds[2], oldBounds[2]) ||
                    exceedsDelta(newLocation.bounds[3], oldBounds[3]))
    {
        return true;
    }

    return false;
}

export function hasLocationChanged(newLocation, oldLat, oldLng, oldZoom, maxDelta = MAX_DELTA) {
    if (newLocation == null)
        return false;
    if (newLocation.zoom !== oldZoom)
        return true;

    const latDelta = Math.abs(newLocation.center.lat - oldLat);
    const lngDelta = Math.abs(newLocation.center.lng - oldLng);

    if (latDelta > maxDelta)
        return true;
    if (lngDelta > maxDelta)
        return true;

    return false;
}

export function getLocationFromMap(map) {
  if (!map) return null;
  const bounds = [];
  const mapBounds = map.getBounds();
  if (mapBounds) {
    //! order matters for back-end api !
    bounds.push(mapBounds.getSouthWest().lat());
    bounds.push(mapBounds.getNorthEast().lat());
    bounds.push(mapBounds.getSouthWest().lng());
    bounds.push(mapBounds.getNorthEast().lng());
  }
  const center = map.getCenter()?.toJSON();
  const zoom = map.getZoom();
  return { bounds, center, zoom };
}

//marker playground: http://jsfiddle.net/v1yc13uo/

export function getIconColor(selected, highlighted, pinColorIds, mapType) {
  if (highlighted) {
    return HIGHLIGHTED_FILL;
  // } else if (selected) {
  //   return SELECTED_FILL;
  } else if (pinColorIds?.[mapType] ) {
    return getPinColorValue(pinColorIds?.[mapType]);
  }
  else if (mapType === window.google.maps.MapTypeId.SATELLITE || mapType === window.google.maps.MapTypeId.HYBRID || mapType?.includes('satellite')) {
    return SATELLITE_DEFAULT_FILL;
  }
  return DEFAULT_FILL;
}

export function getIconBorderColor(selected, highlighted, hasPinDisplayType, valueColor, pinColorIds, mapType) {
  if (highlighted) {
    return HIGHLIGHTED_FILL;
  } else if (selected) {
    return SELECTED_FILL;
  } else if (mapType === window.google.maps.MapTypeId.SATELLITE || mapType === window.google.maps.MapTypeId.HYBRID || mapType?.includes('satellite')) {
    return SATELLITE_DEFAULT_FILL;
  } else if (hasPinDisplayType) {
    return valueColor;
  } else if (pinColorIds?.[mapType]) {
    return getPinColorValue(pinColorIds[mapType]);
  }
  return DEFAULT_FILL;
}

export function createAggregateIcon(selected = false, mapType = window.google.maps.MapTypeId.ROADMAP, dataField, colorMatrix) {
  if (dataField !== 'propertiesCount' && !selected) {
    return {
      path: "M46.5,16.5c0,8.84-10.3,16-23,16s-23-7.16-23-16S10.8.5,23.5.5,46.5,7.66,46.5,16.5Z",
      fillColor: colorMatrix.valueColor,
      fillOpacity: selected ? 1 : 0.9,
      scale: selected ? 1 : 0.87,
      strokeColor: colorMatrix.valueColor, //'alpha 70% and 50%
      strokeWeight: 10,
      labelOrigin: p(24, 17),
      anchor: p(24, 38), // p(24, 17)
      strokeOpacity: 0.5
    }
  } else {
    if (selected)
      return selectedAggregateIcon;
    if (mapType === window.google.maps.MapTypeId.SATELLITE || mapType === window.google.maps.MapTypeId.HYBRID || mapType?.includes('satellite'))
      return satelliteAggregateIcon;
    return defaultAggregateIcon;
  }
}

export function createPropertyIcon(selected = false, mapType = window.google.maps.MapTypeId.ROADMAP) {
  if (selected)
    return selectedPropertyIcon;
  if (mapType === window.google.maps.MapTypeId.SATELLITE || mapType === window.google.maps.MapTypeId.HYBRID || mapType?.includes('satellite'))
    return satellitePropertyIcon;
  return defaultPropertyIcon;
}

// export function createPropertyIcon(selected = false, fill = DEFAULT_FILL) {
//     return {
//         //path: "M 9,0 L 2,8 4,8 4,14 14,14 14,8 16,8 9,0",
//         path: "M 21,0 L 2,18 7,18 7,35 35,35 35,18 40,18",
//         scale: selected ? 0.9 : 0.7,
//         strokeWeight: 0,
//         fillColor: fill,
//         fillOpacity: selected ? 1 : 0.9,
//         //size: new google.maps.Size(28, 28),
//         anchor: p(10, 10),
//         //origin: p(30, 30),
//         //scaledSize: new google.maps.Size(20, 20)
//     }
// }

export function createPropertyWithInfoIcon(selected = false, fill = DEFAULT_FILL) {
    return {
        background: fill,
        color: `white`,
        padding: '4px 6px 4px 6px',
        borderRadius: `4px`,
        opacity: selected ? 1 : 0.9
    }
}

export function createMapPinIcon() {
    return {
        path: "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z",
        scale: 1.5,
        strokeWeight: 1,
        strokeColor: '#ffffff',
        fillColor: "#ce2d78",
        fillOpacity: 1,
        //size: new google.maps.Size(28, 28),
        anchor: p(10, 10),
        //origin: p(30, 30),
        //scaledSize: new google.maps.Size(20, 20)
    }
}

export function getLabelColor(pinColorIds, mapType, selected, highlighted) {
  // if (highlighted) {
  //   return 'white';
  // } else if (selected) {
  //   return 'white';
  if (pinColorIds?.[mapType]) { // Determine black/white text based on background color (from https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color)
    const bgColor = getPinColorValue(pinColorIds[mapType]);
    var color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) ?
      'black' : 'white';
  } else if ((mapType === window.google.maps.MapTypeId.SATELLITE || mapType === window.google.maps.MapTypeId.HYBRID || mapType?.includes('satellite'))) {
    return "black";
  }
  return "white";
}

export function createLabel(pin, pinDisplayType, propertiesCountFieldObj, color = "white", isLoading = false) {
    let nullText = isLoading ? "Loading..." : "-n/a-";
    const text = pinDisplayType && pin?.data?.[pinDisplayType.dataField] != null
      ? formatValue(pin.data[pinDisplayType.dataField], pinDisplayType.format, true, nullText)
      : nullText;

    let t = `${text}`;
    const propCountFormatted = propertiesCountFieldObj ? formatValue(pin.data.propertiesCount, propertiesCountFieldObj.format, true, '-n/a-') : null;
    return {
        propCountFormatted,
        text: t,
        color: color,
        fontWeight: "bold",
        fontSize: "13px"
    };
}

export function createPosition(lat, lng) {
    return new google.maps.LatLng(lat, lng);
}

export function createPolygonCoordinates(shape) {
  if (shape && shape.polygons && shape.polygons.length > 0) {
    var coordsArray = [];
    for (let p = 0; p < shape.polygons.length; p++) {
      const polygon = shape.polygons[p];
      var coords = [];
      for (let c = 0; c < polygon.Coordinates.length; c++) {
        const coordinate = polygon.Coordinates[c];
        coords.push({ lat: coordinate.Latitude, lng: coordinate.Longitude });
      }
      coordsArray.push(coords);
    }
    return coordsArray;
  } else {
    return null;
  }
}

export function createCustomShapeCoordinates(shape) {
  if (shape && shape.polygons && shape.polygons.length > 0) {
    var coordsArray = [];
    for (let p = 0; p < shape.polygons.length; p++) {
      const polygon = shape.polygons[p];

      coordsArray.push(mapCoordinates(polygon.Shell));

      // hole coordinate arrays are already reversed on server
      polygon.Holes.map((hole) => {
        coordsArray.push(mapCoordinates(hole));
      });
    }

    return coordsArray;
  } else {
    return null;
  }
}

export function mapCoordinates(coordinates) {
  return coordinates.map((c) => {
    return { lat: c.Latitude, lng: c.Longitude };
  });
}

export function getShapeById(shapesData, shapeId) {
    if (shapesData && shapesData.length > 0 && shapeId) {
        const q = shapesData.filter(x=>x.id === shapeId);
        return q != null && q.length === 1 ? q[0] : null;
    } else {
        return null;
    }
}

export function getNoDataColor(mapType) {
    if (mapType === window.google.maps.MapTypeId.SATELLITE || mapType === window.google.maps.MapTypeId.HYBRID || mapType?.includes('satellite')) {
        return SATELLITE_DEFAULT_NO_DATA;
    }
    return DEFAULT_NO_DATA;
}

export function getColorForShape(shapeColorPalette, shape, shapesData, colorByField, colorByDataType) {
    const colorMatrix = { };
    if (shape && shapesData && shapesData.length > 0) {
      if (colorByField && colorByDataType) { // If field is not None
        if (colorByDataType === 'number') { // For numeric fields (ie can be colored by data)
          colorMatrix.value = shape[colorByField];
          const maxObj = _.maxBy(shapesData, colorByField);
          const minObj = _.minBy(shapesData, colorByField);
          if (minObj && maxObj) {
              colorMatrix.maxValue = maxObj[colorByField];
              colorMatrix.minValue = minObj[colorByField];
              colorMatrix.midValue = colorMatrix.maxValue - ((colorMatrix.maxValue - colorMatrix.minValue) / 2);
          }
          if (colorMatrix.value != null && colorMatrix.minValue != null && colorMatrix.midValue != null && colorMatrix.maxValue != null) {
              colorMatrix.valueColor = calculateColor(shapeColorPalette, colorMatrix.minValue, colorMatrix.maxValue, colorMatrix.midValue, colorMatrix.value);
              colorMatrix.minValueColor = calculateColor(shapeColorPalette, colorMatrix.minValue, colorMatrix.maxValue, colorMatrix.midValue, colorMatrix.minValue);
              colorMatrix.midValueColor = calculateColor(shapeColorPalette, colorMatrix.minValue, colorMatrix.maxValue, colorMatrix.midValue, colorMatrix.midValue);
              colorMatrix.maxValueColor = calculateColor(shapeColorPalette, colorMatrix.minValue, colorMatrix.maxValue, colorMatrix.midValue, colorMatrix.maxValue);
          }
        } else {
          const value = shape[colorByField];
          const hasNoValue = !value || value === 'N'; // Handling for string Y/N values from GUD
          colorMatrix.valueColor = hasNoValue ? DEFAULT_NO_DATA : calculateColor(shapeColorPalette, 1, 1, 1, 1);
        }
      } else { // If field is None, use single color for all shapes
        colorMatrix.valueColor = calculateColor(shapeColorPalette, 0, 0.5, 1, 0.5); // From middle of palette
      }
    }
    if (!colorMatrix.valueColor || colorMatrix.valueColor === "rgb(NaN, NaN, NaN)" || colorMatrix.valueColor.indexOf("NaN") >= 0) {
        colorMatrix.valueColor = DEFAULT_NO_DATA;
    }
    return colorMatrix;
}

export function getColorForPin(pinColorPalette, value, minVal, maxVal, noDataColor = DEFAULT_NO_DATA) {
  const colorMatrix = { };
  if (value != null && maxVal != null && minVal != null) {
    colorMatrix.value = value;
    colorMatrix.maxValue = maxVal;
    if (value > colorMatrix.maxValue) {
      colorMatrix.value = colorMatrix.maxValue;
    }
    colorMatrix.minValue = minVal;
    if (value < colorMatrix.minValue) {
      colorMatrix.value = colorMatrix.minValue;
    }
    colorMatrix.midValue = colorMatrix.maxValue - ((colorMatrix.maxValue - colorMatrix.minValue) / 2);
    if (colorMatrix.value != null && colorMatrix.minValue != null && colorMatrix.midValue != null && colorMatrix.maxValue != null) {
      colorMatrix.valueColor = calculateColor(pinColorPalette, colorMatrix.minValue, colorMatrix.maxValue, colorMatrix.midValue, colorMatrix.value);
      colorMatrix.minValueColor = calculateColor(pinColorPalette, colorMatrix.minValue, colorMatrix.maxValue, colorMatrix.midValue, colorMatrix.minValue);
      colorMatrix.midValueColor = calculateColor(pinColorPalette, colorMatrix.minValue, colorMatrix.maxValue, colorMatrix.midValue, colorMatrix.midValue);
      colorMatrix.maxValueColor = calculateColor(pinColorPalette, colorMatrix.minValue, colorMatrix.maxValue, colorMatrix.midValue, colorMatrix.maxValue);
    }
  }
  if (!colorMatrix.valueColor || colorMatrix.valueColor === "rgb(NaN, NaN, NaN)" || colorMatrix.valueColor.indexOf("NaN") >= 0) {
    colorMatrix.valueColor = noDataColor;
  }
  return colorMatrix;
}

// IQR method (exclude values outside of middle 50% x 1.5)
export function getIQRBounds(data, iqrMultiplier = 1.5) {
  const sortedArray = data.sort((a, b) => a - b);
  const getPercentile = (array, percentile) => {
    const index = Math.floor(percentile * array.length);
    return array[index];
  };
  const Q1 = getPercentile(sortedArray, 0.25); // 25th percentile
  const Q3 = getPercentile(sortedArray, 0.75); // 75th percentile
  const IQR = Q3 - Q1; // Interquartile Range
  const lowerBound = Q1 - iqrMultiplier * IQR; // Lower bound for outliers
  const upperBound = Q3 + iqrMultiplier * IQR;

  const hasNoRange = IQR === 0; // IQR can be 0 in cases where most of the dataset is the same value (for example, narrow range of beds or baths). In this case, use the full unfiltered dataset instead of the IQR subset.
  const filteredArray = hasNoRange ? sortedArray : sortedArray.filter(val => val >= lowerBound && val <= upperBound);

  return {
    lower: filteredArray[0],
    upper: filteredArray[filteredArray.length - 1]
  }
}

function p(x, y) { return new google.maps.Point(x, y); }

export function getMapCoordinates(map) {
  const location = getLocationFromMap(map);

  if (!location) {
    return null;
  }

  const { bounds } = location;

  if (bounds.length) {
    return {
      south: bounds[0],
      north: bounds[1],
      west: bounds[2],
      east: bounds[3],
    }
  }
}

export function isLatLngOnTheScreen(latLng, map) {
  const coords = getMapCoordinates(map);
  const isObject = _.isPlainObject(latLng);
  const isArray = Array.isArray(latLng);

  if (coords) {
    if (isObject) {
      const isLat = latLng.lat > coords.south && latLng.lat < coords.north;
      const isLng = latLng.lng > coords.west && latLng.lng < coords.east;

      return isLat && isLng;
    } else if (isArray) {
      let response = [];
      latLng.forEach(item => {
        const isLat = item.lat > coords.south && item.lat < coords.north;
        const isLng = item.lng > coords.west && item.lng < coords.east;

        response.push(isLat && isLng);
      })
      return !response.includes(false);
    }
  }

  return false;
}

export function extendBoundsToObject(bounds, object, mapRef) {
  if (!bounds || !mapRef?.current) return bounds;
  switch (object.type) {
    case Constants.ViewsObjectType.PIN:
      if (object.position) {
        bounds.extend(object.position);
      }
      break;
    case Constants.ViewsObjectType.SHAPE:
    case Constants.ViewsObjectType.LINE:
      if (object.data?.length) {
        object.data.forEach(latLng => { bounds.extend(latLng) });
      }
      break;
    case Constants.ViewsObjectType.CIRCLE:
      if (object.data?.bounds) {
        const objBounds = new google.maps.LatLngBounds(object.data.bounds);
        bounds.extend(objBounds.getNorthEast());
        bounds.extend(objBounds.getSouthWest());
      } else if (object.data?.position) {
        bounds.extend(object.data.position);
      }
      break;
    case Constants.ViewsObjectType.LABEL:
      if (object.data) {
        bounds.extend(object.data);
      }
      break;
    case Constants.ViewsObjectType.DISTANCEMEASURING:
      if (object.data?.coordinates) {
        object.data.coordinates.forEach(latLng => { bounds.extend(latLng) });
      }
      break;
    default: break;
  }
  return bounds;
}

export function fitBoundsWithZoom(map, bounds, maxZoom) { 
  if (map.getZoom() < 6) { // Workaround to prevent incorrect fitting when map is at high levels
    map.setZoom(6);
  }
  map.fitBounds(bounds);
  if (maxZoom != null && map.getZoom() > maxZoom) {  // Optional max zoom level, used by View on Explore function to prevent zooming too far in on a single property
    map.setZoom(maxZoom)
  }
}

export function generatePolygonAroundPoint(centerLat, centerLng, radiusMiles, numSides) {
  const earthRadiusMiles = 3958.8; // Earth's radius in miles
  const coords = [];

  // Convert degrees to radians
  const degToRad = (deg) => deg * Math.PI / 180;
  const radToDeg = (rad) => rad * 180 / Math.PI;

  const degreesBetweenPoints = 360 / numSides;
  for (let i = 0; i < numSides; i++) {
      const angleDeg = degreesBetweenPoints * i;
      const angleRad = degToRad(angleDeg);

      // Calculate offset in latitude and longitude
      const latOffset = (radiusMiles / earthRadiusMiles) * Math.cos(angleRad);
      const lngOffset = (radiusMiles / earthRadiusMiles) * Math.sin(angleRad) / Math.cos(degToRad(centerLat));

      const pointLat = centerLat + radToDeg(latOffset);
      const pointLng = centerLng + radToDeg(lngOffset);

      coords.push({ lat: pointLat, lng: pointLng });
  }
  coords.push(coords[0]); // Add first point to end to close out polygon
  return coords;
}